// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  max-height: calc(100% - 32px - env(safe-area-inset-bottom));
  position: fixed;
  top: 0;
  width: 100%;
}

.navbar-container {
  /* border-bottom: 1px solid var(--text-color); */
  height: 64px;
  position: relative;
  background: var(--tertiary-background-color);
}

.navbar-content {
  align-items: center;
  /* border-bottom: 1px solid #808080; */
  display: flex;
  height: 64px;
  padding: 0 30px;
  box-shadow: 0 2px 7px 0 rgba(0,0,0,.09);
}

.navbar-links {
  display: flex;
  visibility: visible;
}

.navbar-logo {
  text-decoration: none;
  display: flex;
  background: radial-gradient(circle, var(--text-color) 0%, var(--text-color) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 25px; 
  font-weight: 800; 
  font-family: "Tussilago", "Montserrat", sans-serif; 
}

.navbar-link {
  display: block;
  visibility: visible;
  text-decoration: none;
  align-items: center;
  border-radius: 36px;
  box-sizing: border-box;
  display: inline-flex;
  height: 44px;
  justify-content: center;
  overflow: hidden;
  padding: 0px 32px;
  position: relative;
  text-align: center;
  white-space: nowrap;
  background-color: var(--highlight-color);
  border: 1px solid var(--highlight-color);
  color: var(--background-color);
  min-width: 112px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  cursor: pointer;
}

.navbar-link:hover {
  opacity: 0.85;
}

.navbar-link.admin {
  border: 1px solid var(--highlight-color);
  background: none;
}

a .navbar-link.admin{
  color: var(--highlight-color);
  background: none;
}

.navbar-link a {
  text-decoration: none;
  color:var(--background-color);
}

.navbar-link button {
  background: none;
  margin-top: 0px;
  color:var(--background-color);
  text-decoration: none;
}

@media (min-width: 768px) {
  .navbar-link {
    min-width: 140px;
  }
}

.navbar-link-spacer {
  width: 12px;
}

.navbar-spacer {
  flex-grow: 1;
}

.menu-button-wrapper {
  -webkit-font-smoothing: antialiased;
  display: flex; /* Ensure the wrapper is also a flex container */
  align-items: center; /* Center the menu button vertically */
  height: 100%; /* Make it take the full height of the navbar */
}

.menu-button {
  appearance: none;
  background: none;
  border: 0px;
  color: unset;
  padding: 0px;
  text-align: unset;
  display: flex;
}

.menu-button:hover {
  background: none;
}

.menu-bar {
  transform-origin: center center 0px;
  transition: transform 300ms;
}

.menu-bar .top-bar {
  transform-origin: center; 
}

.menu-bar .bottom-bar {
  transform-origin: center;
  transform: rotate(45deg) translate3d(0px, -6.5px, 0px);
}

@media (max-width: 768px) {
  .menu-button-wrapper {
    display: block;
    visibility: visible;
  }
}

.menu-bar .top-bar rect {
  transition: transform 300ms ease, opacity 300ms ease;
}

.menu-bar .bottom-bar rect {
  transition: transform 300ms ease, opacity 300ms ease;
}

.rotate-bar-top {
  transform-origin: center center 0px;
  transition: transform 300ms;
  transform: rotate(-45deg) translate3d(0px, 6.5px, 0px);
}

.rotate-bar-bottom {
  transform-origin: center center 0px;
  transition: transform 300ms;
  transform: rotate(45deg) translate3d(0px, -6.5px, 0px)
}

.menu-open .bottom-bar rect:nth-of-type(1) {
  opacity: 0;
}

.drawer-menu-content {
  z-index: 2;
  padding: 24px;
  background-color: var(--background-color);
  inset: 65px 0px 32px;
  box-sizing: border-box;
  height: 100vh;
  overflow: hidden scroll;
  position: fixed;
}

.drawer-menu-content-list-wrapper {
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0px;
  padding: 0px;
}

.drawer-menu-content-list-item {
  display: block;
  padding: 0px;
  position: relative;
  white-space: nowrap;
  margin-left: 0px;
  margin-top: 20px;
}

.drawer-menu-content-list-item-wrapper {
  background-color: var(--background-color);
  box-sizing: border-box;
  width: 100%;
}

.drawer-menu-content-list-item-link {
  text-decoration: none;
  display: block;
  text-align: start;
  color: var(--text-color);
  background: none;
  padding: 0px;
  margin: 0px;
}

.drawer-menu-content-list-item-link:hover {
  color: var(--highlight-color);
  background: none;
}

.drawer-menu-content-list-item-link-text {
  font-family: "Eastlane Book", "Montserrat", sans-serif; 
  font-size: 32px;
  font-weight: 400;
  letter-spacing: -0.5px;
  line-height: 34px;
  font-style: normal;
}`, "",{"version":3,"sources":["webpack://./src/Navbar.css"],"names":[],"mappings":"AAEA;EACE,2DAA2D;EAC3D,eAAe;EACf,MAAM;EACN,WAAW;AACb;;AAEA;EACE,gDAAgD;EAChD,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,YAAY;EACZ,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,iFAAiF;EACjF,6BAA6B;EAC7B,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,wCAAwC;EACxC,8BAA8B;EAC9B,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,aAAa,EAAE,gDAAgD;EAC/D,mBAAmB,EAAE,sCAAsC;EAC3D,YAAY,EAAE,+CAA+C;AAC/D;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,sDAAsD;AACxD;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,sDAAsD;AACxD;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yCAAyC;EACzC,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;EACtD,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["@import './variables.css';\n\n.navbar {\n  max-height: calc(100% - 32px - env(safe-area-inset-bottom));\n  position: fixed;\n  top: 0;\n  width: 100%;\n}\n\n.navbar-container {\n  /* border-bottom: 1px solid var(--text-color); */\n  height: 64px;\n  position: relative;\n  background: var(--tertiary-background-color);\n}\n\n.navbar-content {\n  align-items: center;\n  /* border-bottom: 1px solid #808080; */\n  display: flex;\n  height: 64px;\n  padding: 0 30px;\n  box-shadow: 0 2px 7px 0 rgba(0,0,0,.09);\n}\n\n.navbar-links {\n  display: flex;\n  visibility: visible;\n}\n\n.navbar-logo {\n  text-decoration: none;\n  display: flex;\n  background: radial-gradient(circle, var(--text-color) 0%, var(--text-color) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-size: 25px; \n  font-weight: 800; \n  font-family: \"Tussilago\", \"Montserrat\", sans-serif; \n}\n\n.navbar-link {\n  display: block;\n  visibility: visible;\n  text-decoration: none;\n  align-items: center;\n  border-radius: 36px;\n  box-sizing: border-box;\n  display: inline-flex;\n  height: 44px;\n  justify-content: center;\n  overflow: hidden;\n  padding: 0px 32px;\n  position: relative;\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--highlight-color);\n  border: 1px solid var(--highlight-color);\n  color: var(--background-color);\n  min-width: 112px;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.navbar-link:hover {\n  opacity: 0.85;\n}\n\n.navbar-link.admin {\n  border: 1px solid var(--highlight-color);\n  background: none;\n}\n\na .navbar-link.admin{\n  color: var(--highlight-color);\n  background: none;\n}\n\n.navbar-link a {\n  text-decoration: none;\n  color:var(--background-color);\n}\n\n.navbar-link button {\n  background: none;\n  margin-top: 0px;\n  color:var(--background-color);\n  text-decoration: none;\n}\n\n@media (min-width: 768px) {\n  .navbar-link {\n    min-width: 140px;\n  }\n}\n\n.navbar-link-spacer {\n  width: 12px;\n}\n\n.navbar-spacer {\n  flex-grow: 1;\n}\n\n.menu-button-wrapper {\n  -webkit-font-smoothing: antialiased;\n  display: flex; /* Ensure the wrapper is also a flex container */\n  align-items: center; /* Center the menu button vertically */\n  height: 100%; /* Make it take the full height of the navbar */\n}\n\n.menu-button {\n  appearance: none;\n  background: none;\n  border: 0px;\n  color: unset;\n  padding: 0px;\n  text-align: unset;\n  display: flex;\n}\n\n.menu-button:hover {\n  background: none;\n}\n\n.menu-bar {\n  transform-origin: center center 0px;\n  transition: transform 300ms;\n}\n\n.menu-bar .top-bar {\n  transform-origin: center; \n}\n\n.menu-bar .bottom-bar {\n  transform-origin: center;\n  transform: rotate(45deg) translate3d(0px, -6.5px, 0px);\n}\n\n@media (max-width: 768px) {\n  .menu-button-wrapper {\n    display: block;\n    visibility: visible;\n  }\n}\n\n.menu-bar .top-bar rect {\n  transition: transform 300ms ease, opacity 300ms ease;\n}\n\n.menu-bar .bottom-bar rect {\n  transition: transform 300ms ease, opacity 300ms ease;\n}\n\n.rotate-bar-top {\n  transform-origin: center center 0px;\n  transition: transform 300ms;\n  transform: rotate(-45deg) translate3d(0px, 6.5px, 0px);\n}\n\n.rotate-bar-bottom {\n  transform-origin: center center 0px;\n  transition: transform 300ms;\n  transform: rotate(45deg) translate3d(0px, -6.5px, 0px)\n}\n\n.menu-open .bottom-bar rect:nth-of-type(1) {\n  opacity: 0;\n}\n\n.drawer-menu-content {\n  z-index: 2;\n  padding: 24px;\n  background-color: var(--background-color);\n  inset: 65px 0px 32px;\n  box-sizing: border-box;\n  height: 100vh;\n  overflow: hidden scroll;\n  position: fixed;\n}\n\n.drawer-menu-content-list-wrapper {\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  margin: 0px;\n  padding: 0px;\n}\n\n.drawer-menu-content-list-item {\n  display: block;\n  padding: 0px;\n  position: relative;\n  white-space: nowrap;\n  margin-left: 0px;\n  margin-top: 20px;\n}\n\n.drawer-menu-content-list-item-wrapper {\n  background-color: var(--background-color);\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.drawer-menu-content-list-item-link {\n  text-decoration: none;\n  display: block;\n  text-align: start;\n  color: var(--text-color);\n  background: none;\n  padding: 0px;\n  margin: 0px;\n}\n\n.drawer-menu-content-list-item-link:hover {\n  color: var(--highlight-color);\n  background: none;\n}\n\n.drawer-menu-content-list-item-link-text {\n  font-family: \"Eastlane Book\", \"Montserrat\", sans-serif; \n  font-size: 32px;\n  font-weight: 400;\n  letter-spacing: -0.5px;\n  line-height: 34px;\n  font-style: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
